import { jsx } from 'react/jsx-runtime';
import { useOutlet } from 'react-router-dom';
import { DefaultTechDocsHome } from './DefaultTechDocsHome.esm.js';

const TechDocsIndexPage = (props) => {
  const outlet = useOutlet();
  return outlet || /* @__PURE__ */ jsx(DefaultTechDocsHome, { ...props });
};

export { TechDocsIndexPage };
//# sourceMappingURL=TechDocsIndexPage.esm.js.map
